import React from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { colors } from '@style-guide/config';

import Button from '@style-guide/components/Button';

import getActiveFilters from './services/getActiveFilters';

import Wrapper from './components/Wrapper';
import Header from './components/Header';
import Title from './components/Title';
import Body from './components/Body';
import Item from './components/Item';

const FilterCloud = ({
  updateSearchFilter,
  clearSearchFilters,
  searchFilterValues,
}) => {
  const activeFilters = getActiveFilters(searchFilterValues);
  const hasActiveFilters = is.not.empty(activeFilters);

  const renderCloudFilters = () => {
    const activeFilterKeys = Object.keys(activeFilters);

    const mapTitle = {
      keyword: 'Keyword',
      practiceAreas: 'Practice Areas',
      areasOfLaw: 'Areas Of Law',
      certifications: 'Certified Specialist',
      dateRange: 'Date Range',
      locations: 'City',
      cleFormat: 'Format',
      otherResources: 'Other Areas of Interest',
      publications: 'Publications',
      resourceTypes: 'Resource Types',
      languages: 'Languages',
      section: 'Sections',
      firstName: 'First Name',
      lastName: 'Last Name',
      lawFirm: 'Law Firm',
      eventCategories: 'Meeting Type',
      creditHours: 'CLE Credit Hour',
      eventFormat: 'Event Format',
    };

    const activeFilterKeysWithIds = activeFilterKeys.map((item, index) => ({
      FilterValue: item,
      FilterId: index,
    }));

    const filtersToRender = activeFilterKeysWithIds.map((item, index) => {
      const onClickCb = () => {
        if (item.FilterValue === 'keyword') {
          updateSearchFilter('keyword', '');
        } else if (item.FilterValue === 'cleFormat') {
          updateSearchFilter('cleFormat', null);
        } else if (item.FilterValue === 'dateRange') {
          updateSearchFilter('dateRange', {
            start: null,
            end: null,
          });
        } else if (item.FilterValue === 'locations') {
          updateSearchFilter('locations', []);
        } else if (item.FilterValue === 'practiceAreas') {
          updateSearchFilter('practiceAreas', []);
        } else if (item.FilterValue === 'areasOfLaw') {
          updateSearchFilter('areasOfLaw', []);
        } else if (item.FilterValue === 'certifications') {
          updateSearchFilter('certifications', []);
        } else if (item.FilterValue === 'otherResources') {
          updateSearchFilter('otherResources', []);
        } else if (item.FilterValue === 'publications') {
          updateSearchFilter('publications', []);
        } else if (item.FilterValue === 'resourceTypes') {
          updateSearchFilter('resourceTypes', []);
        } else if (item.FilterValue === 'section') {
          updateSearchFilter('section', []);
        } else if (item.FilterValue === 'languages') {
          updateSearchFilter('languages', []);
        } else if (item.FilterValue === 'firstName') {
          updateSearchFilter('firstName', '');
        } else if (item.FilterValue === 'lastName') {
          updateSearchFilter('lastName', '');
        } else if (item.FilterValue === 'lawFirm') {
          updateSearchFilter('lawFirm', '');
        } else if (item.FilterValue === 'eventCategories') {
          updateSearchFilter('eventCategories', []);
        } else if (item.FilterValue === 'creditHours') {
          updateSearchFilter('creditHours', []);
        } else if (item.FilterValue === 'eventFormat') {
          updateSearchFilter('eventFormat', null);
        }
      };

      return (
        <Item
          onClick={onClickCb}
          key={item.FilterId}
          id={`filterCloudOption${index}`}
        >
          <FontAwesomeIcon
            icon={faTimesCircle}
            style={{
              color: colors.red,
              marginRight: '5px',
              fontSize: '1.2rem',
            }}
          />
          <span>{mapTitle[item.FilterValue]}</span>
        </Item>
      );
    });

    if (filtersToRender.length > 0) {
      return filtersToRender;
    }

    return <div>No filters applied</div>;
  };

  const renderClearCloudFilters = () => {
    if (hasActiveFilters) {
      return (
        <Button
          variant="primary"
          onClick={() => clearSearchFilters()}
          id="filterCloudClearAllButton"
        >
          Clear all
        </Button>
      );
    }

    return undefined;
  };

  return (
    <Wrapper>
      <Header>
        <Title>Filtered By</Title>
      </Header>
      <Body>
        <div>
          {renderCloudFilters()}
        </div>
        {renderClearCloudFilters()}
      </Body>
    </Wrapper>
  );
};

FilterCloud.propTypes = {
  searchFilterValues: PropTypes.shape({
    keyword: PropTypes.string,
    practiceAreas: PropTypes.arrayOf(Object),
    areasOfLaw: PropTypes.arrayOf(Object),
    cleFormat: PropTypes.arrayOf(Object),
    dateRangeStart: PropTypes.string,
    dateRangeEnd: PropTypes.string,
    locations: PropTypes.arrayOf(Object),
    otherAreasOfInterest: PropTypes.arrayOf(Object),
    publications: PropTypes.arrayOf(Object),
    resourceTypes: PropTypes.arrayOf(Object),
    eventCategories: PropTypes.arrayOf(Object),
    eventFormat: PropTypes.string,
  }).isRequired,
  updateSearchFilter: PropTypes.func.isRequired,
  clearSearchFilters: PropTypes.func.isRequired,
};

export default FilterCloud;
